module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Message_04-dd04c0381c3da663e550d85bbc8c10ec.jpg";